export const createUrlWithSearchParams = (url: string) => {
    const currentUrl = new URL(window.location.href);

    const newUrl = new URL(url, window.location.origin);

    if (newUrl.origin === window.location.origin) {
        const flags = currentUrl.searchParams.get('flags');

        if (flags) {
            newUrl.searchParams.set('flags', flags);
        }
    }

    return newUrl.toString();
};
